// Size finder UI (v7), part 1: state, form and validation.
var cly_FIT_LABEL = { slim: 'Slim', regular: 'Regular', oversized: 'Oversized' };
var cly_FIT_COPY = {
  slim: 'for a closer, tailored fit',
  regular: 'for a true-to-size, balanced fit',
  oversized: 'for a relaxed, oversized look'
};
var cly_FIT_ORDER = ['slim', 'regular', 'oversized'];

// h in cm and w in kg once validated. Values are kept while the page stays open.
var cly_state = { unitH: 'cm', unitW: 'kg', h: null, w: null, fit: 'regular' };
var cly_modal = null;
var cly_lastFocus = null;
var cly_prevOverflow = '';
var cly_downOnOverlay = false;

function cly_el(id) { return document.getElementById(id); }
function cly_esc(s) {
  return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
}
function cly_toNumber(value) {
  var s = String(value == null ? '' : value).trim().replace(',', '.');
  return /^\d+(\.\d+)?$/.test(s) ? parseFloat(s) : NaN;
}
function cly_buildItems() { return cly_mapSizes(PRODUCT_SIZES, PRODUCT_SIZE_MAP); }
// "S(US 2-4)" -> "S": the big recommendation shows the short label.
function cly_shortLabel(v) { return String(v).replace(/\s*\(.*\)\s*$/, '') || String(v); }

function cly_readHeight(unit) {
  var cm;
  if (unit === 'ftin') {
    var ftRaw = cly_el('cly-h-ft').value.trim();
    var inRaw = cly_el('cly-h-in').value.trim();
    var ft = cly_toNumber(ftRaw);
    var inch = inRaw === '' ? 0 : cly_toNumber(inRaw);
    if (ftRaw === '' || isNaN(ft) || ft < 3 || ft > 8 || Math.floor(ft) !== ft) return { error: 'Enter feet as a whole number between 3 and 8.', field: 'cly-h-ft' };
    if (isNaN(inch) || inch < 0 || inch >= 12) return { error: 'Inches must be between 0 and 11.9.', field: 'cly-h-in' };
    cm = (ft * 12 + inch) * 2.54;
  } else {
    var v = cly_toNumber(cly_el('cly-h-value').value);
    if (isNaN(v) || v <= 0) return { error: 'Please enter your height.', field: 'cly-h-value' };
    cm = unit === 'm' || (unit === 'cm' && v < 3) ? v * 100 : v;   // "1.75" in cm is read as metres
  }
  if (cm < 100 || cm > 250) return { error: 'Height must be between 100 and 250 cm.', field: unit === 'ftin' ? 'cly-h-ft' : 'cly-h-value' };
  return { cm: cm };
}
function cly_readWeight(unit) {
  var v = cly_toNumber(cly_el('cly-w-value').value);
  if (isNaN(v) || v <= 0) return { error: 'Please enter your weight.', field: 'cly-w-value' };
  var kg = unit === 'lb' ? v * 0.45359237 : v;
  if (kg < 30 || kg > 200) return { error: 'Weight must be between 30 and 200 kg (66 to 440 lb).', field: 'cly-w-value' };
  return { kg: kg };
}

function cly_fillHeight() {
  var unit = cly_state.unitH, val = '', ft = '', inch = '';
  if (cly_state.h !== null) {
    if (unit === 'ftin') {
      var totalIn = cly_state.h / 2.54, f = Math.floor(totalIn / 12);
      ft = String(f);
      inch = String(Math.round((totalIn - f * 12) * 10) / 10);
    } else if (unit === 'm') {
      val = (cly_state.h / 100).toFixed(2);
    } else {
      val = String(Math.round(cly_state.h));
    }
  }
  cly_el('cly-h-value').value = val;
  cly_el('cly-h-ft').value = ft;
  cly_el('cly-h-in').value = inch;
  cly_el('cly-h-value').hidden = unit === 'ftin';
  cly_el('cly-h-ft').hidden = unit !== 'ftin';
  cly_el('cly-h-in').hidden = unit !== 'ftin';
  cly_el('cly-h-unit').value = unit;
}
function cly_fillWeight() {
  var unit = cly_state.unitW, val = '';
  if (cly_state.w !== null) val = String(Math.round((unit === 'lb' ? cly_state.w * 2.20462 : cly_state.w) * 10) / 10);
  cly_el('cly-w-value').value = val;
  cly_el('cly-w-unit').value = unit;
}
function cly_clearInvalid() {
  ['cly-h-value', 'cly-h-ft', 'cly-h-in', 'cly-w-value'].forEach(function (id) { cly_el(id).removeAttribute('aria-invalid'); });
  cly_el('cly-error').hidden = true;
}
function cly_showError(message, fieldId) {
  var box = cly_el('cly-error');
  box.textContent = message;
  box.hidden = false;
  var field = fieldId && cly_el(fieldId);
  if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
}

function cly_fitSelectorHtml(prefix, label) {
  var zones = cly_FIT_ORDER.map(function (k) {
    var on = cly_state.fit === k;
    return '<button type="button" class="cly-size-zone" role="radio" data-cly-fit-set="' + k + '" aria-checked="' + on + '" tabindex="' + (on ? '0' : '-1') + '">' + cly_FIT_LABEL[k] + '</button>';
  }).join('');
  return '<div class="cly-size-fitsel"><p class="cly-size-fitsel-label" id="' + prefix + '-label">' + label + '</p>' +
    '<div class="cly-size-zones" role="radiogroup" aria-labelledby="' + prefix + '-label">' + zones + '</div></div>';
}
function cly_formHtml() {
  return '<p class="cly-size-lead">Tell us your height and weight and we’ll match you to your size in this style.</p>' +
    '<fieldset class="cly-size-group"><legend>Height</legend>' +
      '<div class="cly-size-row">' +
        '<input class="cly-size-input" id="cly-h-value" type="text" inputmode="decimal" autocomplete="off" aria-label="Height" placeholder="e.g. 175">' +
        '<input class="cly-size-input" id="cly-h-ft" type="text" inputmode="numeric" autocomplete="off" aria-label="Feet" placeholder="ft" hidden>' +
        '<input class="cly-size-input" id="cly-h-in" type="text" inputmode="decimal" autocomplete="off" aria-label="Inches" placeholder="in" hidden>' +
        '<select class="cly-size-select" id="cly-h-unit" aria-label="Height unit">' +
          '<option value="cm">cm</option><option value="m">m</option><option value="ftin">ft / in</option>' +
        '</select>' +
      '</div>' +
    '</fieldset>' +
    '<fieldset class="cly-size-group"><legend>Weight</legend>' +
      '<div class="cly-size-row">' +
        '<input class="cly-size-input" id="cly-w-value" type="text" inputmode="decimal" autocomplete="off" aria-label="Weight" placeholder="e.g. 70">' +
        '<select class="cly-size-select" id="cly-w-unit" aria-label="Weight unit">' +
          '<option value="kg">kg</option><option value="lb">lb</option>' +
        '</select>' +
      '</div>' +
    '</fieldset>' +
    '<p id="cly-error" class="cly-size-error" role="alert" hidden></p>' +
    '<div class="cly-size-actions"><button type="button" id="cly-next" class="cly-size-btn">Find my size</button></div>';
}

function cly_submit() {
  cly_clearInvalid();
  var h = cly_readHeight(cly_state.unitH);
  if (h.error) return cly_showError(h.error, h.field);
  var w = cly_readWeight(cly_state.unitW);
  if (w.error) return cly_showError(w.error, w.field);
  cly_state.h = h.cm;
  cly_state.w = w.kg;
  cly_renderResult('value');
}
function cly_changeUnit(kind, unit) {
  if (kind === 'h') {
    var h = cly_readHeight(cly_state.unitH);
    if (!h.error) cly_state.h = h.cm;
    cly_state.unitH = unit;
    cly_fillHeight();
  } else {
    var w = cly_readWeight(cly_state.unitW);
    if (!w.error) cly_state.w = w.kg;
    cly_state.unitW = unit;
    cly_fillWeight();
  }
  cly_clearInvalid();
}
function cly_setFit(fit) {
  if (!cly_FIT_LABEL[fit]) return;
  cly_state.fit = fit;
  cly_modal.querySelectorAll('[data-cly-fit-set]').forEach(function (b) {
    var on = b.getAttribute('data-cly-fit-set') === fit;
    b.setAttribute('aria-checked', on);
    b.setAttribute('tabindex', on ? '0' : '-1');
  });
  if (!cly_el('cly-result').hidden) cly_renderResult('fit');
}